import _extends from "@babel/runtime-corejs3/helpers/extends";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _sortInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/sort";
import React, { forwardRef, useContext, useImperativeHandle, useRef } from 'react';
import { Table as BaseTable, useTablePipeline } from '@kdcloudjs/table';
import ConfigContext from '../config-provider/ConfigContext';
import Checkbox from '../checkbox/index';
import Radio from '../radio/index';
import { Spin, Empty } from '../index';
import useRowSelection from './feature/rowSelection';
import useRowDetail from './feature/rowDetail';
import useFilter from './feature/filter';
import useSort from './feature/sort';
import useAutoRowSpan from './feature/autoRowSpan';
import classNames from 'classnames';
import useTreeMode from './feature/treeMode';
import useColumnResize from './feature/columnResize';
import useColumnDrag from './feature/columnDrag';
import useContextMenu from './feature/contextMenu';
import useRangeSelection from './feature/useRangeSelection';
import useＭergeCellHover from './feature/mergeCellHover';
import devWarning from '../_utils/devwarning';
import useFooterDataSource from './feature/useFooterDataSource';
var Table = /*#__PURE__*/forwardRef(function (props, ref) {
  var columns = props.columns,
      dataSource = props.dataSource,
      columnDrag = props.columnDrag,
      columnResize = props.columnResize,
      primaryKey = props.primaryKey,
      rowSelection = props.rowSelection,
      rowDetail = props.rowDetail,
      filter = _filterInstanceProperty(props),
      sort = _sortInstanceProperty(props),
      autoRowSpan = props.autoRowSpan,
      treeMode = props.treeMode,
      customPrefixcls = props.prefixCls,
      className = props.className,
      style = props.style,
      components = props.components,
      isLoading = props.isLoading,
      footerDataSource = props.footerDataSource,
      useVirtual = props.useVirtual,
      estimatedRowHeight = props.estimatedRowHeight,
      emptyCellHeight = props.emptyCellHeight,
      hasHeader = props.hasHeader,
      useOuterBorder = props.useOuterBorder,
      defaultColumnWidth = props.defaultColumnWidth,
      getRowProps = props.getRowProps,
      getTableProps = props.getTableProps,
      contextMenu = props.contextMenu,
      rangeSelection = props.rangeSelection,
      cssVariables = props.cssVariables,
      stickyScrollHeight = props.stickyScrollHeight,
      scrollbarWidth = props.scrollbarWidth,
      scrollLoad = props.scrollLoad;

  var _useContext = useContext(ConfigContext),
      getPrefixCls = _useContext.getPrefixCls,
      prefixCls = _useContext.prefixCls;

  var tablePrefixCls = getPrefixCls(prefixCls, customPrefixcls);
  var tableCls = classNames(tablePrefixCls, className);
  var pipeline = useTablePipeline({
    components: {
      Checkbox: (components === null || components === void 0 ? void 0 : components.Checkbox) || Checkbox,
      Radio: (components === null || components === void 0 ? void 0 : components.Radio) || Radio
    }
  }).primaryKey(primaryKey === undefined ? '' : primaryKey).input({
    columns: columns,
    dataSource: dataSource
  });
  var pipelineRef = useRef(pipeline);
  pipelineRef.current = pipeline; // if (footerDataSource) {
  //   // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //   // @ts-ignore
  //   pipeline.footerDataSource(footerDataSource)
  // }

  useImperativeHandle(ref, function () {
    var _a, _b, _c, _d;

    return {
      api: {
        getColumns: (_a = pipelineRef.current.getColumns) === null || _a === void 0 ? void 0 : _a.bind(pipelineRef.current),
        getDataSource: (_b = pipelineRef.current.getDataSource) === null || _b === void 0 ? void 0 : _b.bind(pipelineRef.current),
        getFooterDataSource: (_c = pipelineRef.current.getFooterDataSource) === null || _c === void 0 ? void 0 : _c.bind(pipelineRef.current),
        clearRangeSelection: (_d = pipelineRef.current.clearRangeSelection) === null || _d === void 0 ? void 0 : _d.bind(pipelineRef.current)
      }
    };
  });
  /* -------------------------------------------------------------------------- */

  /* features                                                                   */

  /* -------------------------------------------------------------------------- */

  useRowSelection(pipeline, rowSelection);
  useRowDetail(pipeline, rowDetail);
  useFilter(pipeline, filter);
  useSort(pipeline, sort);
  useAutoRowSpan(pipeline, autoRowSpan);
  useTreeMode(pipeline, treeMode);
  useColumnResize(pipeline, columnResize);
  useColumnDrag(pipeline, columnDrag);
  useContextMenu(pipeline, contextMenu);
  useRangeSelection(pipeline, rangeSelection);
  useＭergeCellHover(pipeline);
  useFooterDataSource(pipeline, footerDataSource);
  /* -------------------------------------------------------------------------- */

  /* after useTablePipeline, merge pipeline.getProps result                     */

  /* -------------------------------------------------------------------------- */

  if (typeof getRowProps === 'function') {
    pipeline.appendRowPropsGetter(getRowProps);
  } else {
    devWarning(true, 'table', "parameter 'getRowProps' should be a function but here it is ".concat(getRowProps));
  }

  if (typeof getTableProps === 'function') {
    var tableProps = getTableProps();
    pipeline.addTableProps(tableProps);
  } else {
    devWarning(true, 'table', "parameter 'getTableProps' should be a function but here it is ".concat(getTableProps));
  }

  return /*#__PURE__*/React.createElement(BaseTable, _extends({}, pipeline.getProps(), {
    className: tableCls,
    style: style,
    isLoading: isLoading,
    components: {
      LoadingIcon: (components === null || components === void 0 ? void 0 : components.LoadingIcon) || function () {
        return /*#__PURE__*/React.createElement(Spin, {
          type: "container"
        });
      },
      EmptyContent: (components === null || components === void 0 ? void 0 : components.EmptyContent) || function () {
        return /*#__PURE__*/React.createElement(Empty, null);
      }
    },
    useVirtual: useVirtual,
    estimatedRowHeight: estimatedRowHeight,
    emptyCellHeight: emptyCellHeight,
    hasHeader: hasHeader,
    useOuterBorder: useOuterBorder,
    defaultColumnWidth: defaultColumnWidth,
    cssVariables: cssVariables,
    stickyScrollHeight: stickyScrollHeight,
    scrollbarWidth: scrollbarWidth,
    scrollLoad: scrollLoad
  }));
});
Table.displayName = 'Table';
export default Table;